import { TranslationService } from 'src/app/shared';
import { InvoiceLineItemUpsertDto } from '../../dto/invoice-line-item-upsert.dto';
import { InvoiceUpsertDto } from '../../dto/invoice-upsert.dto';
import { BillingDto } from '../../../revenue/shared/billing/dto/billing.dto';
import { UserSummaryDto } from '../../../users/shared/dto/user-summary.dto';
import { RevenueItem } from '../../../revenue/shared/revenue-items/revenue-item.model';
import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'wl-invoice-line-items-list',
  templateUrl: './invoice-line-items-list.component.html',
  styleUrls: ['./invoice-line-items-list.component.less'],
  providers: [ConfirmationService],
    standalone: false
})
export class InvoiceLineItemsListComponent implements OnInit {
  @Input() invoice: InvoiceUpsertDto;
  @Input() allRevenueItems: RevenueItem[];
  @Input() allUsers: UserSummaryDto[];
  @Input() billingDto: BillingDto;
  @Input() isNewMemberInvoice: boolean;

  constructor(private _translationService: TranslationService, private _confirmationService: ConfirmationService) {}

  ngOnInit() {}

  addLineItem() {
    if (!this.invoice.LineItems) {
      this.invoice.LineItems = [];
    }
    const today = new Date();
    const newInvoiceLineItem = {
      ApplyDate: today,
      ServicePeriod_StartPeriod: today,
      ServicePeriod_EndPeriod: new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() - 1),
      Quantity: 1,
      BasePrice: 0,
      FlatFee: 0,
      AdjustedAmountDue: 0,
      TaxLineItems: [],
      Adjustments: [],
      Payments: [],
      InvoiceNum: this.invoice.InvoiceHeader.InvoiceNum,
      AdjustmentAmountToApply: 0,
    } as InvoiceLineItemUpsertDto;

    if (this.isNewMemberInvoice && this.billingDto) {
      newInvoiceLineItem.BillingId = this.billingDto.BillingId;
      newInvoiceLineItem.UnitPrice = this.billingDto.AmountPerCycle;
      newInvoiceLineItem.Item = this.billingDto.RevenueItem;
      newInvoiceLineItem.ItemNum = this.billingDto.ItemNum;
      //newInvoiceLineItem._revenueItem = this.allRevenueItems.find(x => x.ItemNum === this.billingDto.ItemNum);
      //newInvoiceLineItem.Descr = newInvoiceLineItem._revenueItem.Descr;
      if (this.billingDto.AnchorDay) {
        const startPeriod = new Date(today.getFullYear(), today.getMonth(), this.billingDto.AnchorDay);
        newInvoiceLineItem.ServicePeriod_StartPeriod = startPeriod;
        newInvoiceLineItem.ServicePeriod_EndPeriod = new Date(
          startPeriod.getFullYear() + 1,
          startPeriod.getMonth(),
          startPeriod.getDate() - 1
        );
      }
    }

    this.invoice.LineItems.push(newInvoiceLineItem);
  }

  removeLineItem(index: number) {
    const lineItem = this.invoice.LineItems[index];
    if (lineItem.LineItemId) {
      if ((lineItem.Adjustments && lineItem.Adjustments.length > 0) || (lineItem.Payments && lineItem.Payments.length > 0)) {
        this._translationService
          .get('invoices.invoice-builder.line-items-tab.adjustments-payments-warning-message')
          .then((data: string) => {
            this._confirmationService.confirm({
              message: data,
              accept: () => {
                lineItem.DeleteLineItem = true;
              },
              reject: () => {
                this._confirmationService.close();
              },
            });
          });
      } else {
        lineItem.DeleteLineItem = true;
      }
    } else {
      this.invoice.LineItems.splice(index, 1);
    }
  }
}
